export default {
    category: {
        cta: "Produkte anzeigen"
    }
}